/** Matrice de permissions de la spec § 3.3, comme donnee et non comme code. */
export const STAFF_ROLES = [
    'ADMIN',
    'MANAGER',
    'SALES',
    'WAREHOUSE',
    'COURIER',
    'FINANCE',
];
export const PERMISSIONS = [
    'orders.read',
    'orders.items.read',
    'orders.status.write',
    'orders.create',
    'orders.edit',
    'orders.cancel',
    'orders.discount',
    'orders.price.override',
    'orders.export',
    'payments.read',
    'payments.refund',
    'payments.confirm',
    'products.read',
    'products.write',
    'products.price.write',
    'inventory.write',
    'inventory.adjust',
    'inventory.count',
    'inventory.cost.read',
    'purchasing.write',
    'purchasing.receive',
    'suppliers.write',
    'reviews.moderate',
    'customers.read',
    'customers.write',
    'customers.export',
    'delivery.write',
    'staff.manage',
    'templates.write',
    'legal.publish',
    'settings.write',
    'audit.read',
];
export const ROLE_LABELS = {
    ADMIN: 'Administrateur',
    MANAGER: 'Manager',
    SALES: 'Ventes',
    WAREHOUSE: 'Entrepôt',
    COURIER: 'Livreur',
    FINANCE: 'Finances',
};
/**
 * `orders.items.read` materialise la regle de discretion n° 4 : le livreur voit
 * la commande, jamais son contenu.
 */
export const ROLE_PERMISSIONS = {
    ADMIN: [...PERMISSIONS],
    MANAGER: [
        'orders.read',
        'orders.items.read',
        'orders.status.write',
        'orders.create',
        'orders.edit',
        'orders.cancel',
        'orders.discount',
        'orders.export',
        'payments.read',
        'payments.confirm',
        'products.read',
        'products.write',
        'inventory.write',
        'inventory.adjust',
        'inventory.count',
        'purchasing.write',
        'purchasing.receive',
        'suppliers.write',
        'reviews.moderate',
        'customers.read',
        'customers.write',
        'customers.export',
        'delivery.write',
        'audit.read',
    ],
    SALES: [
        'orders.read',
        'orders.items.read',
        'orders.status.write',
        'orders.create',
        'orders.edit',
        'payments.read',
        'payments.confirm',
        'products.read',
        'reviews.moderate',
        'customers.read',
        'customers.write',
    ],
    WAREHOUSE: [
        'orders.read',
        'orders.items.read',
        'orders.status.write',
        'products.read',
        'inventory.write',
        'inventory.adjust',
        'inventory.count',
        'purchasing.write',
        'purchasing.receive',
        'suppliers.write',
        'delivery.write',
    ],
    COURIER: ['orders.read', 'orders.status.write'],
    FINANCE: [
        'orders.read',
        'payments.read',
        'payments.refund',
        'payments.confirm',
        'customers.read',
        'audit.read',
    ],
};
export function can(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
//# sourceMappingURL=rbac.js.map